import { supabase } from './supabase';
import { youtubeWatchUrl, youtubeThumbnail } from './youtubeLinks';

// ⚠️ The ONE client copy. Must match the allowlist inside BOTH submit_video and
// create_upload_submission (004 → 039 → 044). ExploreScreen and
// CuratedVideosScreen kept their own hardcoded lists until 044, which is how
// adding a category silently missed two screens.
export const VIDEO_CATEGORIES = [
  'Self-Care',
  'Client Support',
  'De-escalation',
  'Communication',
  'Documentation',
  'Career Growth',
  'Wellness',
  'Other',          // catch-all, added 044
];

// The filter row on ExploreScreen, which needs an "All" that is not a real
// category and must never be submitted as one.
export const VIDEO_FILTER_CATEGORIES = ['All', ...VIDEO_CATEGORIES];

// Sends a YouTube video linked in a just-created post to the library approval
// queue, linked back to that post (migration 039). Runs AFTER create_post has
// succeeded: the post is the thing the member asked for, so a failed suggestion
// must never cost them the post. Returns which outcome happened so the post
// page can say so.
export const suggestVideoFromPost = async ({ videoId, title, category, postId }) => {
  const { error } = await supabase.rpc('submit_video', {
    p_youtube_url: youtubeWatchUrl(videoId),
    p_youtube_id: videoId,
    p_title: title,
    p_thumbnail_url: youtubeThumbnail(videoId),
    p_commentary: null,
    p_category: category,
    p_post_title: null,
    p_source_post_id: postId,
  });
  if (!error) return 'submitted';
  if (error.message?.includes('duplicate_video')) return 'duplicate';
  console.error('submit_video (from post):', error);
  return 'failed';
};

export const VIDEO_SUGGESTION_MESSAGES = {
  submitted: 'Posted. Your video was also sent to the library for review.',
  duplicate: 'Posted. That video is already in the library or waiting for review.',
  failed: "Posted, but the video couldn't be sent to the library. You can submit it from the video library page.",
};
